export default function HeroSection() {
    return (
      <section className="py-12 bg-center text-white text-center relative">
        <h1 className="text-6xl font-bold text-white text-center max-[450px]:text-4xl ">
          Великая Отечественная война
        </h1>
        <p className="text-2xl text-white mb-8 max-[450px]:text-xl">
          История о стойкости, героизме, трудолюбии и силе народа.
        </p>
      </section>
    );
  }